import { c as _c } from "react/compiler-runtime";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { useLazyImage } from "@hooks/use-lazy-image";
import { useAppParams } from "@router/router-helper";
import { THUMBNAIL_IMAGE_HEIGHT, THUMBNAIL_IMAGE_WIDTH } from "@styles/common-styles";
import { defaultProjectThumbnail } from "@utils/project-utils";
/**
 * Thumbnail image for the projects table that uses the shared image cache.
 * This ensures images cached by the card view are reused, avoiding redundant network requests
 * when the MUI DataGrid virtualizes rows during scrolling.
 */
export function ProjectTableThumbnail(t0) {
  const $ = _c(3);
  const {
    thumbnailUrl,
    projectId
  } = t0;
  const {
    companyId
  } = useAppParams();
  const src = thumbnailUrl ?? defaultProjectThumbnail;
  const {
    imageUrl
  } = useLazyImage(src, `${companyId}`, "project", projectId);
  const t1 = imageUrl ?? src;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: `${THUMBNAIL_IMAGE_HEIGHT}px`,
      width: `${THUMBNAIL_IMAGE_WIDTH}px`,
      objectFit: "cover"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <ThumbnailImage src={t1} fallbackSrc={defaultProjectThumbnail} alt="Project thumbnail" sx={t2} />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}